<template>
  <div @click="click" v-touch="click" data-name="testimonial-button-wrapper" :class="$style.wrapper">

    <div v-if="testimonial" data-name="testimonial-button-container" :class="$style.container">
      <div data-name="testimonial-button-image-wrapper" :class="$style['image-wrapper']">
        <div :class="$style['image-container']">
          <img :src="testimonial.image" :class="$style.image" :aria-label="testimonial.name + ' profile'" :alt="testimonial.name + ' profile'"/>
        </div>
      </div>
      <div data-name="testimonial-button-content-container" :class="$style.content" v-html="format(testimonial.content)"></div>
    </div>

    <div data-name="view-container" :class="$style.view">
      More
    </div>
  </div>
</template>

<script>
export default {
  props: ['testimonial'],
  mounted() {
    // console.log('testimonialbutton');
  },
  methods: {
    format(text) {
      return text.substring(0, 55) + '...';
    },
    click(e) {
      this.$store.dispatch('updateAppState', {
        state: 'show-testimonials'
      });
    }
  }
};
</script>

<style lang="scss" module>
@import '../assets/css/globals.scss';
.wrapper {
  width: 100%;
  padding-top: 8px;
  padding-bottom: 8px;

  margin-top: 35px;
  margin-left: auto;
  margin-right: auto;

  border-radius: 70px;
  background-color: rgba($black, 0.1);

  transition: background-color 0.3s ease-in-out;

  &:hover,
  &:focus {
    background-color: rgba($black, 0.25);
  }

  color: white;
}

.container {
  height: 100%;
  width: 80%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;

  font-size: 12px;

  @include large {
    font-size: 14px;

    cursor: pointer;
  }
}

.image-wrapper {
  margin-right: 8px;
}

.image-container {
  overflow: hidden;
  width: 50px;
  height: 50px;

  border-radius: 50%;
  border: 5px solid $white;


}

.image {
  display: block;
  width: 100%;
}

.content {
  padding-left: 8px;
  text-shadow: 0 0 5px rgba($black, 0.5);

}

.view {
  // display: flex;
  display: none;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 70px;

  background-color: $palmLeaf;
  padding-left: 16px;
  padding-right: 16px;

  font-size: 12px;

  text-align: center;

  font-weight: 700;

  @include medium {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TestimonialButton.vue